
export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-shield-check-line',
      title: 'Powerful Antioxidants',
      description: 'Rich in vitamin E and polyphenols that protect your cells from oxidative stress and support overall cellular health.'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Heart Health Support',
      description: 'High in monounsaturated fats and oleic acid, proven to support cardiovascular health and maintain healthy cholesterol levels.'
    },
    {
      icon: 'ri-fire-line',
      title: 'Anti-Inflammatory Properties',
      description: 'Contains oleocanthal, a natural compound with anti-inflammatory effects comparable to ibuprofen, supporting joint and tissue health.'
    },
    {
      icon: 'ri-brain-line',
      title: 'Cognitive Function',
      description: 'Polyphenols support brain health and may help protect against age-related cognitive decline and neurodegenerative conditions.'
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Weight Management',
      description: 'Healthy fats promote satiety and support metabolic health, making it easier to maintain a balanced diet and healthy weight.'
    },
    {
      icon: 'ri-contrast-drop-2-line',
      title: 'Skin & Beauty',
      description: 'Vitamins and antioxidants nourish skin from within, promoting elasticity, hydration, and a natural, healthy glow.'
    }
  ];

  return (
    <section id="benefits" className="py-24 bg-gradient-to-b from-amber-50/30 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-amber-600 text-sm font-semibold tracking-widest uppercase mb-4 block" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Transform Your Health
          </span>
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Exceptional Health Benefits
          </h3>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Full of <strong>antioxidants</strong> and <strong>anti-inflammatory properties</strong>, high in <strong>polyphenols</strong> — this <strong>olive oil</strong> will change your health and life for the better
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 border border-gray-100"
            >
              <div className="w-14 h-14 bg-amber-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${benefit.icon} text-amber-600 text-2xl`}></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                {benefit.title}
              </h4>
              <p className="text-gray-600 leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center bg-gradient-to-br from-amber-600 to-amber-500 rounded-2xl p-12 text-white shadow-2xl">
          <div>
            <h4 className="text-3xl font-bold mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              The Mediterranean Diet Secret
            </h4>
            <p className="text-lg leading-relaxed mb-6 text-white/95" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              For thousands of years, <strong>Mediterranean olive oil</strong> has been the cornerstone of one of the world's healthiest diets. Scientific research consistently shows that populations consuming high-quality <strong>extra virgin olive oil</strong> enjoy longer lifespans, lower rates of chronic disease, and better overall health.
            </p>
            <p className="text-lg leading-relaxed text-white/95" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Our <strong>early harvest</strong>, <strong>cold-pressed</strong> method ensures maximum retention of these beneficial compounds, delivering the authentic health benefits that have made <strong>Mediterranean olive oil</strong> legendary.
            </p>
          </div>
          
          <div className="relative h-80 rounded-xl overflow-hidden shadow-2xl">
            <img 
              src="https://public.readdy.ai/ai/img_res/99bd55f3b85176f74e77bd6435cdb1e3.jpg" 
              alt="Healthy Mediterranean meal with olive oil"
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-8 text-center">
          <div className="p-6">
            <div className="text-4xl font-bold text-amber-600 mb-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              3000+
            </div>
            <p className="text-gray-700 font-medium" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Years of Mediterranean Tradition
            </p>
          </div>
          <div className="p-6">
            <div className="text-4xl font-bold text-amber-600 mb-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              100%
            </div>
            <p className="text-gray-700 font-medium" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Wild & Natural
            </p>
          </div>
          <div className="p-6">
            <div className="text-4xl font-bold text-amber-600 mb-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              6
            </div>
            <p className="text-gray-700 font-medium" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Generations of Expertise
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
